import { NgComponentOutlet, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import {
  FeatureHeader,
  HeaderRegistryService,
} from '@app/_shared/components/header/header-registry';
import {
  selectRouteData,
  selectUrl,
} from '@app/_store/selectors/router.selectors';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [
    FuseFullscreenComponent,
    MatIcon,
    TitleCasePipe,
    MatIconButton,
    NgComponentOutlet,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  // Always mounted for the whole session, and every binding in the template is a
  // signal read, so OnPush costs nothing and stops the view being checked on
  // unrelated events.
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private router = inject(Router);
  private store = inject(Store);
  private headerRegistry = inject(HeaderRegistryService);

  public currentUrl: Signal<string | undefined> = toSignal(
    this.store.select(selectUrl)
  );
  public routeName: Signal<string> = toSignal(
    this.store.select(selectRouteData).pipe(
      map((data) => {
        return data['name'] || '';
      })
    ),
    { initialValue: '' }
  );
  /**
   * S1. The feature that owns the current route registered its header under the
   * route's `data.name` (see header-registry.ts); the shell just renders the
   * answer. No name registered — the @else branch shows the plain title bar.
   */
  public header: Signal<FeatureHeader | undefined> = computed(() =>
    this.headerRegistry.resolve(this.routeName())
  );
  public isSupportChat: Signal<boolean | undefined> = computed(() => {
    const url = this.currentUrl();
    return url?.includes('support/chat');
  });
  readonly toggleNavigation = output<string>();

  goToSupportChat() {
    const currentUrl = this.currentUrl();
    let chatLink = '/support/contact';

    if (currentUrl?.includes('start')) {
      chatLink = `start/${chatLink}`;
    }

    this.router.navigate([chatLink]);
  }
}
